const {jQuery: $} = window;
import Cookies from 'js-cookie';

export default class Utils {
    /**
     * This is a wrapper for console.log() which does not produce output unless a debug cookie has been set in the user's
     * browser. This is to keep the console less cluttered but still allow for robust debugging when needed. Use console.log()
     * for messages that should always be logged, and this for more detailed output.
     */
    static log(...args) {
        if (Cookies.get("debug") == 1) {
            console.log(...args);
        }
    }

    /**
     * Takes a number value and adds commas to it, ex: 1000000 -> 1,000,000
     *
     * @param {string|number} val
     * @returns {string}
     */
    static commaSeparateNumber(val) {
        while (/(\d+)(\d{3})/.test(val.toString())) {
            val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
        }
        return val;
    }

    /**
     * Parses a URL to determine if it contains a YouTube ID.
     *
     * @param {string} url
     * @returns {string|false}
     */
    static youtubeParser(url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
    }
}